<template>
  <div
    :class="[
      'el-input-number',
      'rt-input-number-icon',
      inputNumberSize ? 'el-input-number--' + inputNumberSize : '',
      { 'is-disabled': inputNumberDisabled },
      { 'is-without-controls': !controls },
      { 'is-controls-right': controlsAtRight },
      { 'is-controls-left': controlsAtLeft }
    ]"
    @dragstart.prevent
  >
    <!-- 原来的类:class="{'is-disabled': minDisabled}" -->
    <span
      v-if="controls && !inputNumberDisabled"
      v-repeat-click="decrease"
      class="el-input-number__decrease"
      :class="controlsMinAtStyle"
      role="button"
      @keydown.enter="decrease"
    >
      <i
        :class="
          `el-icon-${
            controlsAtRight || controlsAtLeft ? 'arrow-down' : 'minus'
          }`
        "
      ></i>
    </span>
    <span
      v-if="controls && !inputNumberDisabled"
      v-repeat-click="increase"
      class="el-input-number__increase"
      role="button"
      :class="controlsMaxAtStyle"
      @keydown.enter="increase"
    >
      <i
        :class="
          `el-icon-${controlsAtRight || controlsAtLeft ? 'arrow-up' : 'plus'}`
        "
      ></i>
    </span>
    <el-input
      ref="input"
      :value="displayValue"
      :placeholder="placeholder"
      :disabled="inputNumberDisabled"
      :size="inputNumberSize"
      :max="max"
      :min="min"
      :name="name"
      :label="label"
      :class="valueStyle"
      @keydown.up.native.prevent="increase"
      @keydown.down.native.prevent="decrease"
      @blur="handleBlur"
      @focus="handleFocus"
      @input="handleInput"
      @change="handleInputChange"
    >
      <slot
        v-if="!controls"
        slot="prefix"
        name="prefix"
      >
        <slot name="prefix" />
      </slot>
      <slot
        v-if="!controls"
        slot="suffix"
        name="suffix"
      >
        <slot name="suffix" />
      </slot>
    </el-input>
  </div>
</template>
<script>
import ElInput from 'element-ui/lib/input';
import Focus from 'element-ui/lib/mixins/focus';
import RepeatClick from 'element-ui/lib/directives/repeat-click';

export default {
  name: 'ElInputNumber',
  mixins: [Focus('input')],
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  // eslint-disable-next-line vue/order-in-components
  directives: {
    repeatClick: RepeatClick
  },
  // eslint-disable-next-line vue/order-in-components
  components: {
    ElInput
  },
  props: {
    step: {
      type: Number,
      default: 1
    },
    stepStrictly: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: Infinity
    },
    min: {
      type: Number,
      default: -Infinity
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {},
    disabled: Boolean,
    size: String,
    controls: {
      type: Boolean,
      default: true
    },
    controlsPosition: {
      type: String,
      default: ''
    },
    // 左右类型-按钮两侧边框
    buttonBorder: {
      type: Boolean,
      default: true
    },
    // 左右类型-按钮两侧背景
    buttonBg: {
      type: String,
      default: 'n-extralight'
    },
    // 左右类型-按钮图标颜色
    iconColor: String,
    // 左右类型-悬浮图标颜色
    hoverIconColor: String,
    // 上下类型按钮
    updownButtonBg: String,
    name: String,
    label: String,
    placeholder: String,
    // 数值颜色
    valColor: String,
    // 数值布局
    valAround: String,
    // 输入框边框颜色
    inputBorder: String,
    precision: {
      type: Number,
      validator (val) {
        return val >= 0 && val === parseInt(val, 10);
      }
    },
    showClose: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentValue: 0,
      userInput: null
    };
  },
  computed: {
    valueStyle () {
      const classList = [];
      // 平台默认初始值“0”，fontcolor 引用“neutral-placeholder”
      if (this.currentValue === 0) {
        classList.push('is-zero');
      }
      // 当值为“0”时，支持fontcolr配置为“neutral- primaryr”
      if (this.valColor && this.currentValue === 0) {
        classList.push(`is-value-${this.valColor}`);
      }
      // 数值默认在数值区域支持左右布局。
      if (this.valAround) {
        classList.push(`is-valaround-${this.valAround}`);
      }
      // 输入框边框颜色
      if (this.inputBorder) {
        classList.push(`is-inputborder-${this.inputBorder}`);
      }
      return classList;
    },
    // 控制odd布局样式
    controlsMinAtStyle () {
      const classList = [];
      // 超过规定最小数值禁用按钮
      if (this.minDisabled) {
        classList.push('is-disabled');
      }
      // 配置左右类型按钮边框|
      if (this.buttonBorder) {
        classList.push('is-button-border');
        classList.push('is-button-left-border');
      }
      // 配置左右类型按钮背景色
      if (this.buttonBg && !this.controlsPosition) {
        classList.push(`is-button-bg`);
        classList.push(`is-button-bg-${this.buttonBg}`);
      }
      // 配置左右类型按钮图标颜色
      if (this.iconColor) {
        classList.push(`is-iconcolor-${this.iconColor}`);
      }
      //  配置左右类型按钮悬浮图标颜色
      if (this.hoverIconColor) {
        classList.push(`is-hovercolor-${this.hoverIconColor}`);
      }
      // 配置左右类型Odd按钮布局
      if (this.controlsPosition) {
        classList.push(`is-controls-${this.controlsPosition}`);
      }
      // 配置上下按钮类型背景
      if (this.updownButtonBg) {
        classList.push(`is-updownbuttonbg-${this.updownButtonBg}`);
      }
      if (this.controlsAtRight || this.controlsAtLeft) {
        classList.push('is-controls');
      }
      return classList;
    },
    // 控制add布局样式
    controlsMaxAtStyle () {
      const classList = [];
      // 超过规定最大数值禁用按钮
      if (this.maxDisabled) {
        classList.push('is-disabled');
      }
      // 配置按钮右侧边框|
      if (this.buttonBorder) {
        classList.push('is-button-border');
        classList.push('is-button-right-border');
      }
      // 配置左右类型按钮背景
      if (this.buttonBg && !this.controlsPosition) {
        classList.push(`is-button-bg`);
        classList.push(`is-button-bg-${this.buttonBg}`);
      }
      // 配置左右类型add按钮布局
      if (this.controlsPosition) {
        classList.push(`is-controls-${this.controlsPosition}`);
      }
      // 配置左右类型按钮图标颜色
      if (this.iconColor) {
        classList.push(`is-iconcolor-${this.iconColor}`);
      }
      //  配置左右类型按钮悬浮图标颜色
      if (this.hoverIconColor) {
        classList.push(`is-hovercolor-${this.hoverIconColor}`);
      }
      // 配置上下按钮类型背景
      if (this.updownButtonBg) {
        classList.push(`is-updownbuttonbg-${this.updownButtonBg}`);
      }
      if (this.controlsAtRight || this.controlsAtLeft) {
        classList.push('is-controls');
      }
      return classList;
    },
    minDisabled () {
      return this._decrease(this.value, this.step) < this.min;
    },
    maxDisabled () {
      return this._increase(this.value, this.step) > this.max;
    },
    numPrecision () {
      const { value, step, getPrecision, precision } = this;
      const stepPrecision = getPrecision(step);
      if (precision !== undefined) {
        if (stepPrecision > precision) {
          console.warn(
            '[Element Warn][InputNumber]precision should not be less than the decimal places of step'
          );
        }
        return precision;
      } else {
        return Math.max(getPrecision(value), stepPrecision);
      }
    },
    controlsAtRight () {
      return this.controls && this.controlsPosition === 'right';
    },
    controlsAtLeft () {
      return this.controls && this.controlsPosition === 'left';
    },
    _elFormItemSize () {
      return (this.elFormItem || {}).elFormItemSize;
    },
    inputNumberSize () {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputNumberDisabled () {
      return this.disabled || !!(this.elForm || {}).disabled;
    },
    displayValue () {
      if (this.userInput !== null) {
        this.$emit('display-value-change', this.userInput);
        return this.userInput;
      }

      let currentValue = this.currentValue;

      if (typeof currentValue === 'number') {
        if (this.stepStrictly) {
          const stepPrecision = this.getPrecision(this.step);
          const precisionFactor = Math.pow(10, stepPrecision);
          currentValue =
            (Math.floor(currentValue / this.step) *
              precisionFactor *
              this.step) /
            precisionFactor;
        }

        if (this.precision !== undefined) {
          currentValue = this.toPrecision(currentValue);
        }
      }
      this.$emit('display-value-change', currentValue);
      return currentValue;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        let newVal = value === undefined ? value : Number(value);
        if (newVal !== undefined) {
          if (isNaN(newVal)) {
            return;
          }

          if (this.stepStrictly) {
            const stepPrecision = this.getPrecision(this.step);
            const precisionFactor = Math.pow(10, stepPrecision);
            newVal =
              (Math.floor(newVal / this.step) * precisionFactor * this.step) /
              precisionFactor;
          }

          if (this.precision !== undefined) {
            newVal = this.toPrecision(newVal, this.precision);
          }
        }
        if (newVal >= this.max) newVal = this.max;
        if (newVal <= this.min) newVal = this.min;
        this.currentValue = newVal;
        this.userInput = null;
        this.$emit('input', newVal);
      }
    }
  },
  mounted () {
    let innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('role', 'spinbutton');
    innerInput.setAttribute('aria-valuemax', this.max);
    innerInput.setAttribute('aria-valuemin', this.min);
    innerInput.setAttribute('aria-valuenow', this.currentValue);
    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
  },
  updated () {
    if (!this.$refs || !this.$refs.input) return;
    const innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('aria-valuenow', this.currentValue);
  },
  methods: {
    toPrecision (num, precision) {
      if (precision === undefined) precision = this.numPrecision;
      if (!this.isEmpty(num)) {
        let str = num.toString();
        if (str.includes('.')) {
          const index = str.indexOf('.');
          str = str.slice(0, index + precision + 1);
        }
        return Number(str);
      }
      return num;
    },
    getPrecision (value) {
      if (value === undefined) return 0;
      const valueString = value.toString();
      const dotPosition = valueString.indexOf('.');
      let precision = 0;
      if (dotPosition !== -1) {
        precision = valueString.length - dotPosition - 1;
      }
      return precision;
    },
    _increase (val, step) {
      if (typeof val !== 'number' && val !== undefined) {
        return this.currentValue;
      }

      const precisionFactor = Math.pow(10, this.numPrecision);
      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
      return this.toPrecision(
        (precisionFactor * val + precisionFactor * step) / precisionFactor
      );
    },
    _decrease (val, step) {
      if (typeof val !== 'number' && val !== undefined) {
        return this.currentValue;
      }

      const precisionFactor = Math.pow(10, this.numPrecision);

      return this.toPrecision(
        (precisionFactor * val - precisionFactor * step) / precisionFactor
      );
    },
    increase () {
      if (this.inputNumberDisabled || this.maxDisabled) return;
      const value = this.value || 0;
      const newVal = this._increase(value, this.step);
      this.setCurrentValue(newVal);
    },
    decrease () {
      if (this.inputNumberDisabled || this.minDisabled) return;
      const value = this.value || 0;
      const newVal = this._decrease(value, this.step);
      this.setCurrentValue(newVal);
    },
    handleBlur (event) {
      this.$emit('blur', event);
    },
    handleFocus (event) {
      this.$emit('focus', event);
    },
    setCurrentValue (newVal) {
      const oldVal = this.currentValue;
      if (typeof newVal === 'number' && this.precision !== undefined) {
        newVal = this.toPrecision(newVal, this.precision);
      }
      if (newVal >= this.max) newVal = this.max;
      if (newVal <= this.min) newVal = this.min;
      if (oldVal === newVal) return;
      this.userInput = null;
      this.$emit('input', newVal);
      this.$emit('change', newVal, oldVal);
      this.currentValue = newVal;
    },
    handleInput (value) {
      this.userInput = value;
    },
    handleInputChange (value) {
      const newVal = value.trim() === '' ? undefined : Number(value);
      if (!isNaN(newVal) || value.trim() === '') {
        this.setCurrentValue(newVal);
      }
      this.userInput = null;
    },
    select () {
      this.$refs.input.select();
    },
    isEmpty (val) {
      return val === undefined || val === null || val === '';
    }

  }
};
</script>



// WEBPACK FOOTER //
// input-number.vue?dd518e00